import { render } from "./NoWallet.vue?vue&type=template&id=18b0f09d&scoped=true"
import script from "./NoWallet.vue?vue&type=script&lang=js"
export * from "./NoWallet.vue?vue&type=script&lang=js"

import "./NoWallet.vue?vue&type=style&index=0&id=18b0f09d&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/magic-shop-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b0f09d"]])

export default __exports__